import { UniformSlot, UniformSlotWrapperComponentProps } from '@uniformdev/canvas-react';

import { GenericTableColumnHeader } from '@/libraries/design/patterns/table/src/generic-table-column-header.tsx';
import {
	GenericTableThead,
	GenericTableHeadRow,
} from '@/libraries/design/patterns/table/src/generic-table-header-row.tsx';
import { GenericTable } from '@/libraries/design/patterns/table/src/generic-table.tsx';

const fragmentWrapper = ({ items }: UniformSlotWrapperComponentProps) => <>{items}</>;

export interface UniformTableProps {
	/**
	 * Whether the first column has a header cell.
	 * When false, a blank presentational <th> is prepended to the column header row.
	 */
	firstColumnHeaderExists?: boolean;
}

const UniformTable = ({ firstColumnHeaderExists = false }: UniformTableProps) => {
	const columnHeadersWrapper = ({ items }: UniformSlotWrapperComponentProps) => {
		// +1 for the blank label column when firstColumnHeaderExists is false
		const headerCellCount = items.length;
		// Only compute equal column widths when there are header cells to count from
		const totalColumns =
			headerCellCount > 0 ? headerCellCount + (firstColumnHeaderExists ? 0 : 1) : 0;
		const colWidth = totalColumns > 0 ? `${(100 / totalColumns).toFixed(4)}%` : undefined;

		return (
			<GenericTableThead colWidth={colWidth}>
				<GenericTableHeadRow>
					{!firstColumnHeaderExists && (
						<GenericTableColumnHeader aria-hidden="true" colWidth={colWidth} />
					)}
					{items}
				</GenericTableHeadRow>
			</GenericTableThead>
		);
	};

	return (
		<GenericTable>
			<UniformSlot name="columnHeaders" wrapperComponent={columnHeadersWrapper} />
			<tbody>
				<UniformSlot name="rows" wrapperComponent={fragmentWrapper} />
			</tbody>
		</GenericTable>
	);
};

export default UniformTable;
